import { render, staticRenderFns } from "./AnnotationTaskItem.vue?vue&type=template&id=c994ffaa&"
import script from "./AnnotationTaskItem.vue?vue&type=script&lang=js&"
export * from "./AnnotationTaskItem.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationTaskItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports